import {IGroup, WiFiSettings} from '@interfaces/group';

export class GetAllGroups {
  static readonly type = '[Groups] Get all groups';

  constructor() {
  }
}

export class FetchGroups {
  static readonly type = '[Groups] Fetch groups by params';

  constructor(public params?: {
    order?: string,
    noGroup?: 1 | 0,
    onSchedule?: 1 | 0
  }) {
  }
}

export class ChangeCurrentGroupPage {
  static readonly type = '[Groups] Set current page param';

  constructor(public currentPage: number) {
  }
}

export class SearchGroups {
  static readonly type = '[Groups] Change search group param';

  constructor(public searchParam: string) {
  }
}

export class SetSelectedGroup {
  static readonly type = '[Groups] Set selected group';

  constructor(public group: IGroup | null) {
  }
}

export class CleanSelectedGroup {
  static readonly type = '[Groups] Clear selected group';

  constructor(public group = null) {
  }
}

export class GetSelectedGroupById {
  static readonly type = '[Groups] Get Selected group by id';

  constructor(public id: number) {
  }
}

export class CreateGroup {
  static readonly type = '[Groups] Create group with media';

  constructor(public name: string,
              public description: string = '',
              public timezone: string,
              public devicesId?: number[]) {
  }
}

export class UpdateGroup {
  static readonly type = '[Groups] Update group';

  constructor(public group: Partial<IGroup>, public groupId: number) {
  }
}

export class UpdateGroupDownloadManagerToggle {
  static readonly type = '[Groups] Update group Download Manager Toggle';

  constructor(public value: boolean, public groupId: number) {
  }
}

export class UpdateScreenLockToggle {
    static readonly type = '[Groups] Update group Screen Lock Toggle';

    constructor(public value: boolean, public groupId: number) {
    }
}

export class UpdateGroupWiFiSettings {
    static readonly type = '[Groups] Update group WiFi Settings';

    constructor(public wifiSettings: Partial<WiFiSettings>, public groupId: number) {
    }
}

export class DeleteGroup {
  static readonly type = '[Groups] Delete group';

  constructor(public id: number) {
  }
}

export class SetGroupDefaultPerPage {
  static readonly type = '[Groups] Set default per page value';
}

export class ChangeGroupsPerPage {
  static readonly type = '[Groups] Change groups per page';

  constructor(public groupsPerPage: number) {
  }
}

export class SetGroupsPerPage {
  static readonly type = '[Groups] Set groups per page';

  constructor(public groupsPerPage: number) {
  }
}

export class ChangeGroupPageWithoutUrlParams {
  static readonly type = '[Groups] Change device current page without saving into url params';

  constructor(public currentPage: number) {
  }
}

export class ChangeGroupSearchParam {
  static readonly type = '[Groups] Change group search param';

  constructor(public searchParam: string) {
  }
}

export class CleanGroupsFromState {
  static readonly type = '[Groups] Clean groups';
}

export class CleanGroupSearchParam {
  static readonly type = '[Groups] Clean group search param';
}
